import { render, staticRenderFns } from "./CrearEmpresa.vue?vue&type=template&id=887891e8&scoped=true"
import script from "./CrearEmpresa.vue?vue&type=script&lang=js"
export * from "./CrearEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887891e8",
  null
  
)

export default component.exports